<!-- Breadcrumb-->
<div class="row pt-2 pb-2">
	<div class="col-sm-9">
		<h4 class="page-title">Datepicker</h4>
		<ol class="breadcrumb">
			<li class="breadcrumb-item"><a href="javaScript:;">Bulona</a>
			</li>
			<li class="breadcrumb-item"><a href="javaScript:;">Forms</a>
			</li>
			<li class="breadcrumb-item active" aria-current="page">Datepicker</li>
		</ol>
	</div>
	<div class="col-sm-3">
		<div ngbDropdown class="btn-group float-sm-right">
			<button type="button" class="btn btn-outline-danger"><i class="fa fa-cog mr-1"></i> Setting</button>
			<button type="button" class="btn btn-danger" id="dropdownBasic5" ngbDropdownToggle> <span class="caret"></span>
			</button>
			<div ngbDropdownMenu aria-labelledby="dropdownBasic5"> 
                <a href="javaScript:;" ngbDropdownItem>Action</a>
				<a href="javaScript:;" ngbDropdownItem>Another action</a>
				<a href="javaScript:;" ngbDropdownItem>Something else here</a>
                <div class="dropdown-divider"></div> 
                <a href="javaScript:;" ngbDropdownItem>Separated link</a>
			</div>
		</div>
	</div>
</div>
<!-- End Breadcrumb-->
<!-- Simple datepicker-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-body">
				<h4 class="card-title text-uppercase">Simple datepicker</h4>
				<ngb-datepicker #dp [(ngModel)]="model" (navigate)="date = $event.next"></ngb-datepicker>
				<hr/>
				<button class="btn btn-sm btn-light mr-2" (click)="selectToday()">Select Today</button>
				<button class="btn btn-sm btn-light mr-2" (click)="dp.navigateTo()">To current month</button>
				<button class="btn btn-sm btn-light mr-2" (click)="dp.navigateTo({year: 2013, month: 2})">To Feb 2013</button>
				<hr/> <pre>Month: {{ date.month }}.{{ date.year }}</pre>
				<pre>Model: {{ model | json }}</pre>
			</div>
		</div>
	</div>
</div>
<!-- / Simple datepicker-->
<!--Datepicker in a popup-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header">Datepicker in a popup</div>
			<div class="card-body">
				<form class="form-inline">
					<div class="form-group">
						<div class="input-group">
							<input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="popupmodel" ngbDatepicker #d="ngbDatepicker">
							<div class="input-group-append">
								<button class="btn btn-light fa fa-calendar" (click)="d.toggle()" type="button"></button>
							</div>
						</div>
					</div>
				</form>
				<hr/> <pre>Model: {{ popupmodel | json }}</pre>
			</div>
		</div>
	</div>
</div>
<!-- / Datepicker in a popup-->
<!-- Multiple months-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-body">
				<h4 class="card-title text-uppercase">Multiple months</h4>
				<ngb-datepicker [displayMonths]="displayMonths" [navigation]="navigation" [showWeekNumbers]="showWeekNumbers" [outsideDays]="outsideDays"></ngb-datepicker>
				<hr/>
				<form class="form-inline">
					<div class="form-group">
						<div class="input-group">
							<input class="form-control" placeholder="yyyy-mm-dd" name="dp" [displayMonths]="displayMonths" [navigation]="navigation" [outsideDays]="outsideDays" [showWeekNumbers]="showWeekNumbers" ngbDatepicker #d2="ngbDatepicker">
							<div class="input-group-append">
								<button class="btn btn-light fa fa-calendar" (click)="d2.toggle()" type="button"></button>
							</div>
						</div>
					</div>
				</form>
				<hr/>
				<div class="d-flex flex-wrap align-content-between p-2">
					<select class="custom-select" [(ngModel)]="displayMonths">
						<option [ngValue]="1">One month</option>
						<option [ngValue]="2">Two months</option>
						<option [ngValue]="3">Three months</option>
					</select>
					<select class="custom-select" [(ngModel)]="navigation">
						<option value="none">Without navigation</option>
						<option value="select">With select boxes</option>
						<option value="arrows">Without select boxes</option>
					</select>
					<select class="custom-select" [(ngModel)]="showWeekNumbers">
						<option [ngValue]="true">Week numbers</option>
						<option [ngValue]="false">No week numbers</option>
					</select>
					<select class="custom-select" [(ngModel)]="outsideDays">
						<option value="visible">Visible outside days</option>
						<option value="hidden">Hidden outside days</option>
						<option value="collapsed">Collapsed outside days</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- / Multiple months-->
<!--Range selection-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-header">Range selection</div>
			<div class="card-body">
				<p>Example of the range selection</p>
				<ngb-datepicker #dp2 (select)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden"></ngb-datepicker>
				<ng-template #t let-date let-focused="focused"> <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)" [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                    </span>
				</ng-template>
				<hr> <pre>From: {{ fromDate | json }} </pre>
				<pre>To: {{ toDate | json }} </pre>
			</div>
		</div>
	</div>
</div>
<!-- / Range selection-->
<!--Disabled datepicker-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-body">
				<h4 class="card-title text-uppercase">Disabled datepicker</h4>
				<ngb-datepicker [(ngModel)]="disabledmodel" [disabled]="disabled"></ngb-datepicker>
				<hr/>
				<button class="btn btn-sm btn-outline-{{disabled ? 'danger' : 'success'}}" (click)="disabled = !disabled">{{ disabled ? "disabled" : "enabled"}}</button>
			</div>
		</div>
	</div>
</div>
<!-- / Disabled datepicker-->
<!--Custom date adapter-->
<div class="row">
	<div class="col-lg-6">
		<div class="card">
			<div class="card-body">
				<h4 class="card-title text-uppercase">Custom date adapter</h4>
				<p>These datepickers use custom Date adapter that lets you use your own model implementation. In this example we are converting from and to a JS native Date object</p>
				<ngb-datepicker #d1 [(ngModel)]="model1" #c1="ngModel"></ngb-datepicker>
				<hr/>
				<button class="btn btn-sm btn-light" (click)="model1 = today">Select Today</button>
				<hr/> <pre>Model: {{ model1 | json }}</pre>
				<pre>State: {{ c1.status }}</pre>
			</div>
		</div>
	</div>
	<div class="col-lg-6">
		<div class="card">
			<div class="card-body">
				<h4 class="card-title text-uppercase">Custom date adapter</h4>
				<form class="form-inline">
					<div class="form-group">
						<div class="input-group">
							<input class="form-control" placeholder="yyyy-mm-dd" name="d2" #c2="ngModel" [(ngModel)]="model2" ngbDatepicker #d3="ngbDatepicker">
							<div class="input-group-append">
								<button class="btn btn-light fa fa-calendar" (click)="d3.toggle()" type="button"></button>
							</div>
						</div>
					</div>
				</form>
				<hr/>
				<button class="btn btn-sm btn-light" (click)="model2 = today">Select Today</button>
				<hr/> <pre>Model: {{ model2 | json }}</pre>
				<pre>State: {{ c2.status }}</pre>
			</div>
		</div>
	</div>
</div>
<!-- / Custom date adapter-->
<!--Custom day view-->
<div class="row">
	<div class="col-lg-12">
		<div class="card">
			<div class="card-body">
				<h4 class="card-title text-uppercase">Custom day view</h4>
				<p>This datepicker uses a custom template to display days. All week-ends are displayed with an orange background.</p>
				<form class="form-inline">
					<div class="form-group">
						<div class="input-group">
							<input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="custommodel" ngbDatepicker [dayTemplate]="customDay" [markDisabled]="isDisabled" #d4="ngbDatepicker">
							<div class="input-group-append">
								<button class="btn btn-light fa fa-calendar" (click)="d4.toggle()" type="button"></button>
							</div>
						</div>
					</div>
				</form>
				<ng-template #customDay let-date let-currentMonth="currentMonth" let-selected="selected" let-disabled="disabled" let-focused="focused"> <span class="custom-day" [class.weekend]="isWeekend(date)" [class.focused]="focused" [class.bg-primary]="selected" [class.hidden]="date.month !== currentMonth" [class.text-muted]="disabled">
                        {{ date.day }}
                    </span>
				</ng-template>
			</div>
		</div>
	</div>
</div>
<!-- / Custom day view-->
<!--Position target-->
<div class="card">
	<div class="card-body">
		<h4 class="card-title text-uppercase">Position target</h4>
		<div class="row">
			<div class="col-lg-12">
				<p>This datepicker uses a custom position target and placement. Popup is positioned according to the toggle button instead of input which is default.</p>
				<form class="form-inline">
					<div class="form-group">
						<div class="input-group">
							<input class="form-control" placeholder="yyyy-mm-dd" name="dp" [(ngModel)]="positionmodel" ngbDatepicker #d5="ngbDatepicker" [placement]="placement" [positionTarget]="buttonEl">
							<div class="input-group-append">
								<button #buttonEl class="btn btn-light fa fa-calendar" (click)="d5.toggle()" type="button"></button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</div>
		<hr/>
		<div class="row">
			<div class="col-sm-3">
				<label for="placement">Placement</label>
				<select id="placement" class="custom-select form-control" [(ngModel)]="placement">
					<option value="top">Top</option>
					<option value="bottom">Bottom</option>
					<option value="left">Left</option>
					<option value="right">Right</option>
				</select>
			</div>
		</div>
	</div>
</div>
<!-- / Custom day view-->